import React, {
	useEffect, useState, useCallback, memo
}from 'react'
import {
	useDispatch, useSelector
}from 'react-redux'
import {
	Popconfirm, Tooltip, Upload
}from 'antd'
import {
	uploadFileAction
}from './actions'
import notice from '../../components/Notice'
import i18n from './localization'
import i18nGlobal from '../../localization'
import validateFile from '../../helpers/validateFile'
import "./style.css"
import "antd/lib/popover/style/index.css"
import File from '../../../public/paper-clip.svg'
import SignedIcon from "../../../public/signedIcon.png"

const UploadFile = memo(({
	defaultFiles,
	disabled,
	listType,
	onChangeCustom,
	fileList,
	title,
	getTransmittalFile,
	onDownload,
	maxCount,
	download = false,
	removeFromList = false,
	notShow,
	removeFiles = undefined,
	canEdit = false,
	className = '',
	multiple = true
}) => {
	const dispatch = useDispatch()
	const [canDelete, setCanDelete] = useState(null)

	const { chosenFilesNames, chosenFiles } = useSelector(state => state.fileReducer)
	const { isRu } = useSelector(state => state.globalReducer)
	const { systemEnvironment } = useSelector(state => state.userReducer)

	const fileNotChosen = file => chosenFilesNames.length === 0 || chosenFilesNames.findIndex(x => x === file.name) === -1

	const deleteFiles = useCallback((params) => {
		dispatch(uploadFileAction.deleteFiels(params))
	}, [dispatch])

	useEffect(() => {
		if (canDelete){
			if (canDelete.url || canDelete.id)
				removeFiles ? removeFiles({ FileId: canDelete.id ?? canDelete.uid }, canDelete) : deleteFiles({ FileIds: [canDelete.id ?? canDelete.uid]})
			if (removeFiles)
				removeFiles({ FileId: canDelete.id ?? canDelete.uid }, canDelete)
			if (!removeFiles || !(canDelete.url || canDelete.id))
				dispatch(uploadFileAction.removeFile(canDelete))
			setCanDelete(false)
		}
	}, [canDelete])

	function removeFromUploadList(file, fileList){
		const index = fileList.findIndex(x => x.uid === file.uid)
		fileList.splice(index, 1)
		if (onChangeCustom)
			onChangeCustom({ fileList: fileList })
	}

	useEffect(() => {
		if (defaultFiles?.length > 0)
			dispatch(uploadFileAction.chooseFiles(defaultFiles))
		return () => {
			dispatch(uploadFileAction.clearFiels())
		}
	}, [])

	const onChange = ({ file, fileList }) => {
		if (fileList.length < chosenFiles.length){
			dispatch(uploadFileAction.chooseFiles(fileList))
			return
		}
		if (fileNotChosen(file))
			dispatch(uploadFileAction.chooseFile(file))
		else
			notice("error", i18n.chooseFileError[isRu], i18n.fileAlreadyChosen[isRu], 5)
	}

	function getSvg(onClick){
		return (
			<svg
				height="12"
				viewBox="0 0 12 12"
				width="12"
				xmlns="http://www.w3.org/2000/svg"
				onClick={ onClick ?? null }
			>
				<path d="M0.088588 0.215749L0.146448 0.146509C0.320008 -0.0270611 0.589438 -0.0463409 0.784308 0.088649L0.853548 0.146509L6 5.29306L11.1464 0.146509C11.32 -0.0270611 11.5894 -0.0463409 11.7843 0.088649L11.8536 0.146509C12.0271 0.320069 12.0464 0.589499 11.9114 0.784369L11.8536 0.853609L6.707 6.00006L11.8536 11.1465C12.0271 11.3201 12.0464 11.5895 11.9114 11.7844L11.8536 11.8537C11.68 12.0272 11.4106 12.0465 11.2157 11.9115L11.1464 11.8537L6 6.70706L0.853548 11.8537C0.679988 12.0272 0.410558 12.0465 0.215688 11.9115L0.146448 11.8537C-0.0271221 11.6801 -0.046402 11.4107 0.088588 11.2158L0.146448 11.1465L5.293 6.00006L0.146448 0.853609C-0.0271221 0.680049 -0.046402 0.410619 0.088588 0.215749L0.146448 0.146509L0.088588 0.215749Z" />
			</svg>
		)
	}

	return (
		<>
			<Upload
				beforeUpload={ file => validateFile(file, isRu, systemEnvironment.maxFileSize) }
				className={ `upload-user-custom ${ className }` }
				customRequest={ null }
				disabled={ disabled }
				fileList={ fileList ?? chosenFiles }
				iconRender={ () => null }
				itemRender={ (originNode, file, fileList) => {
					return (
						<div className="custom-file">
							{file.signerInfo &&
								<Tooltip 
									title={i18n.signer[isRu].format(file.signerInfo)}
									overlayInnerStyle={{ whiteSpace: 'pre-line' }}
									className='signed_icon'
								>
									<img src={SignedIcon}/>
								</Tooltip>
							}
							<Tooltip
								placement="left"
								title={ file.name ?? (file.fileName + (file.fileExtension ?? '')) }
							>
								<span
									style={ { cursor: (download && file.id) ? "pointer" : null } }
									onClick={ () => download && getTransmittalFile(file) }
								>
									{ file.name ?? (file.fileName + (file.fileExtension ?? '')) }
								</span>
							</Tooltip>
							{
								((removeFromList || canEdit) ? true : !download) &&
								(removeFromList ?
									(
										getSvg(() => {
											removeFromUploadList(file, fileList)
										})
									)
									:
									(
										<Popconfirm
											cancelText={ i18nGlobal.no[isRu] }
											okText={ i18nGlobal.yes[isRu] }
											title={ i18n.deleteFileConfirmationMessage[isRu] }
											onConfirm={ () => (canEdit
												? removeFromUploadList(file, fileList)
												: setCanDelete(file)) }
										>
											{ getSvg() }
										</Popconfirm>
									)
								)
							}
						</div>
					)
				} }
				listType={ listType ?? "picture" }
				maxCount={ maxCount ?? null }
				multiple={ multiple }
				onChange={ ((removeFromList || canEdit) ? true : !download) ? onChangeCustom ?? onChange : null }
				onDownload={ onDownload?? null }
				onRemove={ null }
			>
				{
					((notShow ? false : ((removeFromList || canEdit) ? true : !download)) &&
					(
						<Tooltip title={ title ?? (i18nGlobal.downloadFileRulesInfo[isRu]).format(systemEnvironment.maxFileSize / 1024 / 1024) }>
							<div className="add-file">
								<img
									alt={ i18nGlobal.chooseFile[isRu] }
									src={ File }
								/>
								<span>
									{ i18nGlobal.chooseFile[isRu] }
								</span>
							</div>
						</Tooltip>
					))
				}
				{ (Boolean(notShow) &&<a id={ notShow } />) }
			</Upload>
		</>
	)
})

export default UploadFile